import { data } from 'autoprefixer';
import React, { useState } from 'react';
import Option from '../Option/Option';
import './Question.css';
import { toast } from 'react-toastify'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye } from '@fortawesome/free-solid-svg-icons'

const Question = (props) => {
    const { id, question, options, correctAnswer } = props.question;

    const handleSelected = (options) => {
        if (options === correctAnswer) {
            toast.success('Correct Answer', {
                autoClose: 2000,
            })
        } else {
            toast.error('Wrong Answer', {
                autoClose: 2000,
            })
        }
    }

    const handleCorrectAns = () => {
        alert(correctAnswer)
    }

    return (
        <div className='mt-5 bg-slate-200 p-5'>
            <h2>ID: {id}</h2>
            <h2 className='text-2xl font-semibold'>{question}</h2>
            <FontAwesomeIcon onClick={() => handleCorrectAns()} icon={faEye} className='text-4xl text-purple-500 mt-10'></FontAwesomeIcon>
            <div className="options grid grid-cols-2 p-5 w-3/4 mx-auto">
                {
                    options.map(option => <Option
                        key={option.id}
                        option={option}
                        handleSelected={handleSelected}
                    ></Option>)
                }
            </div>
        </div>
    );
};

export default Question;